import './App.css';
import { Routes, Route, Outlet, NavLink } from 'react-router'
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap'
import { Vastaanotto } from './vastaanotto'
import { Tunnesana } from './tunnesana'
import { Valikko } from './valikko'
import { Video} from './video'
import { Feedback } from './feedback'

function Menu() {
  return (
	<>
    <Navbar expand="md" style={{'backgroundColor': '#FF9B64'}}>
      <Container fluid>
        <Navbar.Brand  style={{'padding':'0', 'margin':'0 1rem'}}>
			<img
              src="/Atapley-europe-logo.png"
              width="115"
              height="40"
              className="d-inline-block align-top"
              alt="Publishertools"
            />

		</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
		  	<NavLink className='nav-link' to='/' end>Tunnesana</NavLink>
			<NavLink className='nav-link' to='/reception' end>Vastaanotto</NavLink>
			<NavLink className='nav-link' to='/selection' end>Reseptiikka</NavLink>
			<NavLink className='nav-link' to='/start' end>Lämmittely</NavLink>
			<NavLink className='nav-link' to='/play' end>Harjoite</NavLink>
			<NavLink className='nav-link' to='/end' end>Jäähdyttely</NavLink>
			<NavLink className='nav-link' to='/feedback' end>Palaute</NavLink>
			</Nav>
			<Nav  style={{'marginLeft': 'auto'}}>
            <NavDropdown align='end' title="K. Käyttäjä" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Change Password</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">User Profile</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Settings</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
	<Outlet />
	</>
  )
}



function App() {
  return (
    <div className="App">
	<Routes>
		<Route path='/' element={<Menu />} >
			<Route index element={<Tunnesana />} />
			<Route path='/reception' element={<Vastaanotto />} />
			<Route path='/selection' element={<Valikko />} />
			<Route path='/start' element={<Video title='Lämmittely' videolink='images/warmup.png' />} />
			<Route path='/play' element={<Video title='Harjoite' videolink='images/exercise.png' />} />
			<Route path='/end' element={<Video title='Jäähdyttely' videolink='images/cooldown.png' />} />
			<Route path='/feedback' element={<Feedback />} />
			<Route path='/epub'>
				<Route index element={<div>epub</div>} />
				<Route path='/epub/1' element={<div>epub/1</div>} />
			</Route>
		</Route>
	</Routes>
    </div>
  );
}

export default App;
